import React from 'react';
import {useSelector} from 'react-redux';

import {PopupFullPage} from '../../../components/Popup';
import * as reconnectGuideTypes from '../../../consts/app/reconnectGuideTypes';
import ModalTypes from '../../../enums/app/modalTypes';
import reconnectGuideService from '../../../services/reconnectGuideService';
import {hideModalAction} from '../../../state/ducks/modal';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';
import objUtils from '../../../utils/objUtils';
import CriticalReconnectGuide from './components/CriticalReconnectGuide';
import NotCriticalReconnectGuide from './components/NotCriticalReconnectGuide';
import ReconnectGuideComponent from './components/ReconnectGuideComponent';

const ReconnectDeviceGuidePopup = (props) => {
    const {guideType, isReconnectFailed} = props;
    const {device} = useSelector(makeSelectIotDeviceMergedWithConsumerProduct());
    const deviceType = device?.type;
    const guideDataList = reconnectGuideService.getReconnectListData(deviceType);
    const {reconnectData, notCriticalReconnectData, criticalReconnectData} = guideDataList || {};

    let guideData;
    let GuideComponent;

    switch (guideType) {
        case reconnectGuideTypes.REGULAR:
            GuideComponent = ReconnectGuideComponent;
            guideData = reconnectData || {};
            break;
        case reconnectGuideTypes.NOT_CRITICAL:
            GuideComponent = NotCriticalReconnectGuide;
            guideData = notCriticalReconnectData || {};
            break;
        case reconnectGuideTypes.CRITICAL:
            GuideComponent = CriticalReconnectGuide;
            guideData = criticalReconnectData || {};
            break;
        default:
            break;
    }

    const isGuideDataNotEmpty = !objUtils.isAnyKeys(guideData);

    const hideModalGuide = () => {
        dispatch(hideModalAction(ModalTypes.RECONNECT_DEVICE_GUIDE));
    };

    if (isGuideDataNotEmpty || !GuideComponent) {
        hideModalGuide();
    }

    return (
        <PopupFullPage>
            <GuideComponent
                guideData={guideData}
                hideModalGuide={hideModalGuide}
                isReconnectFailed={isReconnectFailed}
            />
        </PopupFullPage>
    );
};

export default ReconnectDeviceGuidePopup;
